<button *ngIf="!link" (click)="handleClick()" class="secondary-btn {{className}} {{load?'activeLoading':''}}" [style]="style">
  <i class="fas {{icon}}"></i>
  {{text}} <span class="load loading"></span>
</button>


<a *ngIf="link" [routerLink]="[link]" class="secondary-btn {{className}} {{load?'activeLoading':''}}">
  <i class="fas {{icon}}"></i>
  {{text}}
</a>

